import React from "react";
import { useEffect, useState, useMemo, useRef } from "react";
import { viewagreementtermsbypropertyid,addupdateagreementterms,deleteagreementterms} from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import "../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus, eBillsStatus } from "../../../Utilities/enum";
import { addParametersForProfiles } from "../../../Utilities/profileManagement";
import SubNav from "../../navbar/subNav";
import AntdTableExample from "../../input-components/dataTable";
import CustomModal from "../../input-components/Modal";
import TextBox from "../../input-components/textbox";
import ShowValue from "../../input-components/ShowValue";
import { format,parse } from 'date-fns';
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { FormatDateView } from "../../../components/CommonSection/Utility/Utility";


const AgreementActivityList = () => {
    const [billsLists, setBillsLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [propertyType, setPropertyType] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(2);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [openAddAgreement, setOpenAddAgreement] = useState(false);
    const [getDetails,setGetDetails] = useState({});
    const [agreementListDetails , setAgreementListDetails] = useState({})
    const [agreementStartDate , setAgreementStartDate] = useState('')
    const [agreementEndDate , setAgreementEndDate] = useState('')

    const [allBillDetails, setAllBillDetails] = useState({})
    
    var url = new URL(window.location.href);
    var propertyId = url.searchParams.get("propertyId");
    const formRef = useRef();
    const ToastRef = useRef();

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, []);


    useEffect(() => {
        getAgreementActivityList(1,10,propertyId)
    },[])


    const getAgreementActivityList = (currentPage, totalRows,id) => {
        const baseUrl = viewagreementtermsbypropertyid;
        let data = {
            PropertyId: id,
            SortBy: "AddedOn",
            SortOrder: "DESC",
            PageNo: currentPage,
        };
        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let agreementData = response.object;
                    let agreementList = agreementData.tenantAgreementTermDetails
                        .map((inv) => ({
                            type: inv.type,
                            renewalDate: format(new Date(inv.renewalDate), 'dd/MM/yyyy hh:mm'),
                            agreementStart: format(new Date(inv.fromDate), 'dd/MM/yyyy hh:mm'),
                            agreementEnd: format(new Date(inv.toDate), 'dd/MM/yyyy hh:mm'),
                            Cancelled: inv.isCancelled,
                            tenants: inv.tenants,
                            tenantFolioId: inv.tenantFolioId,
                            id:inv.id
                        }));
                    setTotalPages(response.totalCount)
                    setBillsLists(agreementList);
                    setGetDetails(agreementData)
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getBillsList(pageNumber, totalRows);
    };

    const handleEdit = (e, data) => {
        setAgreementListDetails(data);
        setOpenAddAgreement(true);

        // Parse the original date format and convert to yyyy-MM-dd
        const parsedStart = parse(data.agreementStart, 'dd/MM/yyyy HH:mm', new Date());
        const parsedEnd = parse(data.agreementEnd, 'dd/MM/yyyy HH:mm', new Date());

        const formattedStart = format(parsedStart, 'yyyy-MM-dd');
        const formattedEnd = format(parsedEnd, 'yyyy-MM-dd');

        setAgreementStartDate(formattedStart);
        setAgreementEndDate(formattedEnd);
    };

    const actions = [
        { icon: "/assets/images/editing.svg", onClick: (e, data) => handleEdit(e, data) },
        { icon: "/assets/images/trash.png", onClick: (e, data) => handleDelete(e, data) },
    ]

    const handleChange = (e,val) => {
        if(val === "start"){
            setAgreementStartDate(e.target.value)
        }else{
            setAgreementEndDate(e.target.value)
        }

    }

    const closeProperty = () => {
        setOpenAddAgreement(false)
    }

     const AddUpdateAgreement = () => {
        const baseUrl = addupdateagreementterms;
        let data = {
            id: agreementListDetails.id,
            fromDate: agreementStartDate,
            toDate: agreementEndDate,
            tenantFolioId: agreementListDetails.tenantFolioId,
            propertyId: propertyId
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                   ToastRef.current.notify(["success", response.message]);
                   setOpenAddAgreement(false)
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const tabColumns = {
        type: {
            colorMap: {
                "RENEWAL": "blue",
            },
        }
    };

    const handleDelete = (e, data) => {
        e.stopPropagation();
        e.preventDefault();
        const baseUrl = deleteagreementterms + `?termid=${data.id}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "delete")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                    getAgreementActivityList(1,10,propertyId)
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const tenantPortfolioDetails = getDetails?.tenantDetails?.[0]?.tenantFolioDetails;


    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={`Activity for ${getDetails.propertyAddress}`} goback={true} extraData={true}  />
                    <div className="material-work-desk-new bg-white m-3">
                          <ToastAlert ref={ToastRef} />
                    
                        <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
                            <div className="">
                                <span
                                    className={`stat-items ${purpose === eBillsStatus.Due ? 'active' : ''}`}
                                    onClick={() => handleStatClick(eBillsStatus.Due)}
                                >
                                    Leases
                                </span>
                                
                            </div>
                        </div>
                        <AntdTableExample
                            label=""
                            dataSource={billsLists}
                            globalSearch
                            hideCol={"tenantFolioId,id"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            actions={actions}
                            tagColumns={tabColumns}
                        />
                    </div>
                    <CustomModal title={`Add Renewal Dates for ${getDetails.propertyAddress}`} width={600} closable={closeProperty} visible={openAddAgreement} onCancel={closeProperty}
                        modalData={
                            <div>
                                <div className="d-flex">
                                    <div style={{ width: "100%" }}>
                                    <div className="ml-3">
                                        <ShowValue Label="Current Agreement" setData={`${FormatDateView(tenantPortfolioDetails?.agreementStart)}` || "-"} />
                                    </div>
                                        <TextBox isMandatory colVal={12} value={agreementStartDate} type="date" name="date" label={"Agreement Start"} onChange={(e)=>handleChange(e,"start")} />
                                        <TextBox isMandatory colVal={12} value={agreementEndDate} type="date" name="date" label={"Agreement End"} onChange={(e)=>handleChange(e,"end")} />

                                    </div>
                                </div>
                            </div>
                        }
                        footer={
                            <div>
                                    <div className="property-details-buttons">
                                        <button
                                            className="pdb-cancel"
                                            type="reset"
                                            onClick={closeProperty}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="pdb-save-changes"
                                            type="button"
                                            onClick={() => AddUpdateAgreement()}
                                        >
                                            Submit
                                        </button>

                                    </div>
                            </div>
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default AgreementActivityList;
